import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl font-heading font-bold text-primary-500">91</span>
            <span className="text-xl font-heading font-bold text-foreground-50">片库</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(cat.slug)
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索影视资源..."
                className="w-56 px-4 py-2 text-sm bg-background-100 border border-background-300/50 rounded-full text-foreground-200 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 transition-colors"
              />
              <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-300 hover:text-foreground-50 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 pb-4 bg-background-50/95 backdrop-blur-md border-t border-background-200/60">
          <div className="py-3">
            <input
              type="text"
              placeholder="搜索影视资源..."
              className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-300/50 rounded-full text-foreground-200 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50"
            />
          </div>
          <div className="flex flex-col gap-0.5">
            <Link
              to="/"
              className="px-4 py-2.5 text-sm text-foreground-300 hover:text-foreground-50 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-2.5 text-sm text-foreground-300 hover:text-foreground-50 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-2.5 text-sm text-foreground-300 hover:text-foreground-50 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}